export const coreAddresses = {
  balanceTracker: "0x5a3828beA292E5f29725Fa449F9113Cb5E60ADF8",
  eVaultFactory: "0x046a9837A61d6b6263f54F4E27EE072bA4bdC7e4",
  eVaultImplementation: "0x32CFc56917C0025501b34C43f7FE767Ef1EDE3a2",
  eulerEarnFactory: "0x8F01c6640A1c0a6085C79843F861fF0F89b9fED6",
  evc: "0x59f0FeEc4fA474Ad4ffC357cC8d8595B68abE47d",
  permit2: "0xCbe9Be2C87b24b063A21369b6AB0Aa9f149c598F",
  protocolConfig: "0x94047C7daF06a6DE4049365cFa95fb4389a6F9Fe",
  sequenceRegistry: "0xf4C097718c64B6B0A75Cd9e0EF348fD6F176bE67",
} as const
